import type { SearchRequest } from "@/types/api";
import type { TFunction } from "i18next";

/**
 * Build a short human-readable summary of the search parameters.
 * Used as the collapsed trigger label for the search-query section.
 */
export function buildSearchSummary(
  request: SearchRequest,
  t: TFunction,
): string {
  const parts: string[] = [];

  if (request.industry) parts.push(request.industry);
  if (request.location) parts.push(request.location);
  if (request.employee_size && request.employee_size !== "any") {
    parts.push(request.employee_size);
  }

  const kw = request.keywords;
  if (kw && kw.length > 0) {
    if (kw.length === 1) {
      parts.push(kw[0]);
    } else {
      parts.push(t("searchSummary.keywords", { count: kw.length }));
    }
  }

  return parts.length > 0 ? parts.join(", ") : t("searchSummary.allResults");
}
